<template>
  <div>
    <top-bar title="Meus Cartões"/>
    <div class="container" style="max-width: 600px">
      <div v-if="pagamento === '32'">
        <cartoes-mercadopago/>
      </div>
      <div v-if="pagamento === '30'">
        <cartoes-pagarme/>
      </div>
    </div>
  </div>
</template>

<script>

import CartoesMercadopago from "../components/CartoesMercadoPago";
import CartoesPagarme from "../components/CartoesPagarme";
import TopBar from "../components/TopBar";
export default {
  name: 'MeusCartoes',
  components: {TopBar, CartoesPagarme, CartoesMercadopago},
  data() {
    return {
      token: localStorage.getItem('token'),
    }
  },

  created() {
    document.body.classList.remove("modal-open");
    this.url = this.$helpers.getUrlApp(this.$route.params.id || '');

    if (!this.token) {
      this.$router.push(this.url + '/perfil/login');

    } else if (!this.pagamento) {
      this.$router.push(this.url + '/perfil');
    }
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    },

    pagamento() {
      return this.$store.state.cartao_pagamento
    }
  }
}
</script>

<style scoped>
</style>
